import { useContext } from 'react';
import FormContext from '../form-context';

/**
 *
 * @returns the interpreter (service) of the closest FormContext.Provider ancestor or undefined if none
 */
export const useFormService = () => {
  const { formService } = useContext(FormContext);
  return formService;
};
